import script from "./LoginAIO.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAIO.vue?vue&type=script&setup=true&lang=js"

import "./LoginAIO.vue?vue&type=style&index=0&id=6a6cb448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6cb448"]])

export default __exports__